import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const ProfileQuery = graphql(/* GraphQL */ `
  query profile {
    profile {
      ...Profile
    }
  }
`);
